var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15145,0,0,1.15145,-7.57274,-1.0566)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.288,
    cy: 22.629,
    r: 21.712,
    style: {
      fill: "rgb(71,71,71)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.980196,0,0,0.980196,-2.72812,2.81885)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.288,
    cy: 22.629,
    r: 21.712,
    style: {
      fill: "rgb(144,144,144)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.814329,-0.580403,0.580403,0.814329,-9.93154,19.1721)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.718,
    y: 22.596,
    width: 42.563,
    height: 5.025,
    style: {
      fill: "rgb(71,71,71)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.7ebc2aa4681ae5d213dd3ba088f2d65a.svg";
export { ForwardRef as ReactComponent };